/**
 * Powers fields backed by the SpecialOfferFieldView class
 *
 * @author Alexander Zhang (azhang@yext.com)
 */
goog.module('yext.location.SpecialOffer');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const NamedUrl = goog.require('yext.location.NamedUrl');
const helpers = goog.require('yext.location.helpers');

/**
 * Special offer field inherits from the NamedUrl module
 *
 * @constructor
 * @param {!jQuery} $ctx
 */
const SpecialOffer = function($ctx) {
  NamedUrl.call(this, $ctx);
  this.$timestamp = $ctx.find('input[name*=timestamp]');
};
goog.inherits(SpecialOffer, NamedUrl);

/**
 * Updates the field to the state provided
 *
 * @param {!Object} POJO version of namedUrl
 */
SpecialOffer.prototype.set = function(data) {
  SpecialOffer.superClass_.set.call(this, data);
  this.$timestamp.val(data.timestamp);
};

/**
 * Wraps the display content with icon label and
 * returns display mode as human readable html
 *
 * @return {!jQuery} View markup
 */
SpecialOffer.prototype.getDisplayValue = function() {
  var $icon = $('<span>').attr({'class': 'icon-tag'});
  var $wrap = $('<div>').attr({'class': 'specialoffer-view js-specialoffer-view'});

  return $icon.add($wrap.html(this.getDisplayContent()));
};

/**
 * Returns display mode of the content
 *
 * @return {!jQuery|String} View markup
 */
SpecialOffer.prototype.getDisplayContent = function() {
  var $markup = this.name.viewMarkup();

  if (this.indeterminate) {
    return helpers.variousContentMessage();
  } else if (this.url.displayValue() === '') {
    return $markup;
  } else if (yext.isValidUrl(this.url.value())) {
    $markup = this.createLink($markup);
  }
  return $markup;
};

/**
 * Create the link for url in special offer
 *
 * @param content
 */
SpecialOffer.prototype.createLink = function(content) {
  return $('<a>').attr({
    'href': helpers.preprendProtocol(this.getUrlLink()),
    'class': 'no-edit',
    'target': '_blank',
    'tid': 'entity-edit-special-offer-link',
  }).html(content);
};

/**
 * Get the actual link of the URL
 *
 * @return {string}
 */
SpecialOffer.prototype.getUrlLink = function() {
  return this.url.value();
};

exports = SpecialOffer;
